import { useMutation } from '@tanstack/react-query';
import {} from 'infrastructure/hooks/patient/use-patient-info';
import { showResult } from 'infrastructure/hooks/utils';

import { updateBingoCardStatusFn } from './api/updateBingoCardStatusFn';
import { useUpdatePatientInfoCache } from '../patient/use-update-patient-info-cache';

export const useUpdateBingoCardStatus = () => {
  const { updateCache } = useUpdatePatientInfoCache();

  const { mutate, isLoading } = useMutation({
    mutationFn: updateBingoCardStatusFn,
    onSuccess(data, variables) {
      if (data) {
        updateCache(variables.patientGuid, {
          acceptBingoStatus: data.acceptBingoStatus,
        });
      }
      showResult();
    },
  });

  return {
    updateBingoCardStatus: mutate,
    updateBingoCardStatusLoading: isLoading,
  };
};
